<template>
  <div>

    <dropdown
      v-for="(dropdown, index) in metaMenu"
      :modifierClass="null"
      :figureClass="dropdown.figureClass"
      :label="dropdown.label"
      :links="dropdown.links"
      :expanded="dropdown.expanded"
      :index="index"
      :image="dropdown.image">
    </dropdown>

  </div>
</template>

<script>
import Dropdown from './Dropdown'

export default {
  name: 'menu-group',
  components: { Dropdown },
  props: ['metaMenu'],
  data() {
    return {
      hasOpenMenu: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// MenuGroup.vue?3f804e1f